import { Clock, Trash2 } from 'lucide-react';
import { getCategoryById } from '../../data/categories';
import { clearRecentHistory } from '../../utils/recentHistory';

export default function RecentHistory({ t, items, onSelect, onClear }) {
  if (!items.length) return null;

  return (
    <div className="rounded-xl border border-slate-700/80 bg-slate-900/40 p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-sm font-medium text-slate-300">
          <Clock className="w-4 h-4 text-slate-500" />
          {t.recent.title}
        </div>
        <button
          type="button"
          onClick={() => {
            clearRecentHistory();
            onClear();
          }}
          className="text-xs text-slate-500 hover:text-red-400 flex items-center gap-1"
        >
          <Trash2 className="w-3 h-3" />
          {t.recent.clear}
        </button>
      </div>
      <div className="flex flex-wrap gap-2">
        {items.map((item) => {
          const cat = getCategoryById(item.categoryId);
          return (
            <button
              key={`${item.categoryId}-${item.sizeValue}-${item.savedAt}`}
              type="button"
              onClick={() => onSelect(item)}
              className="rounded-lg border border-slate-600 bg-slate-800 px-3 py-2 text-left text-xs hover:border-emerald-600/50 transition-colors"
            >
              <span className="block text-slate-500">{cat?.label || item.categoryId}</span>
              <span className="block text-emerald-400 font-semibold mt-0.5">
                {item.systemId.toUpperCase()} {item.sizeValue}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
